import { mdAlert } from "../../utils/tools";
import env from "md-base-tools/env";
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ifShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('update:show', value);
      }
    },
    isMobile() {
      return env.isMobile();
    }
  },
  mounted() {},
  data() {
    return {
      three_list: [{
        "prize": 1000,
        "task_id": 58,
        "task_status": 0,
        "describe": "",
        "button_name": "去发布",
        "task_name": "发布项目解锁目标",
        "sort_weight": 95
      }, {
        "prize": 1000,
        "task_id": 59,
        "task_status": 0,
        "describe": "",
        "button_name": "去发布",
        "task_name": "发布用户种草活动",
        "sort_weight": 94
      }, {
        "prize": 1000,
        "task_id": 60,
        "task_status": 0,
        "describe": "",
        "button_name": "去发布",
        "task_name": "发布抽奖活动",
        "sort_weight": 93
      }]
    };
  },
  methods: {
    btnAction() {
      mdAlert({
        title: '提示',
        content: '请去PC端项目管理后台操作项目',
        actions: ['好的']
      });
    }
  }
};